import type { ReactNode } from 'react';
import {
  UnsavedChangesProvider,
  type UnsavedChangesProviderProps,
} from '@/components/UnsavedChanges';

interface Props {
  children: ReactNode;
  shouldBlockNavigation?: UnsavedChangesProviderProps['shouldBlockNavigation'];
}

/**
 * Pre-configured UnsavedChangesProvider for new interaction pages.
 */
export const NewInteractionUnsavedChangesProvider = ({
  children,
  shouldBlockNavigation,
}: Props) => {
  return (
    <UnsavedChangesProvider
      dialogTitle="Are you sure you want to leave this page?"
      dialogBody="If you choose to continue, any data you have added for this transaction will be lost"
      submitButtonText="Continue Without Saving"
      shouldBlockNavigation={shouldBlockNavigation}
    >
      {children}
    </UnsavedChangesProvider>
  );
};
